// Admin
export const SET_JWT = 'SET_JWT'
export const SET_OFFERS = 'SET_OFFERS'
export const SET_ADMIN_ACTIVE_NODE = 'SET_ADMIN_ACTIVE_NODE'
export const LOGIN_FAILED = 'LOGIN_FAILED'


// Selection
export const TOGGLE_PLOT_SELECTION = 'TOGGLE_PLOT_SELECTION'
export const SET_BUDGET_SELECTION = 'SET_BUDGET_SELECTION'
export const TOGGLE_HOUSETYPE_SELECTION = 'TOGGLE_HOUSETYPE_SELECTION'
export const TOGGLE_CONFIGURATION_SELECTION = 'TOGGLE_CONFIGURATION_SELECTION'


// Plot


// Budget
export const SET_BUDGET_IGNORE = 'SET_BUDGET_IGNORE'
export const SET_BUDGET_VALUE = 'SET_BUDGET_VALUE'
export const SET_BUDGET_BLOCK = 'SET_BUDGET_BLOCK'


// Nodes
export const SET_ACTIVE_NODE = 'SET_ACTIVE_NODE'
export const SET_NEXT_NODE = 'SET_NEXT_NODE'
export const SET_NODES = 'SET_NODES'
export const TOGGLE_NODES_SELECTION = 'TOGGLE_NODES_SELECTION'

// Area
export const SET_AREA = 'SET_AREA'

// Housetype
export const SET_HOUSETYPE = 'SET_HOUSETYPE'


// Configuration
export const SET_CONFIGURATION = 'SET_CONFIGURATION'

// Offer
export const SET_CLIENT_SELECTION = 'SET_CLIENT_SELECTION'
export const SET_OFFER_PREFILL = 'SET_OFFER_PREFILL'

// Lightbox
export const SET_LIGHTBOX = 'SET_LIGHTBOX'



// WEBPACK FOOTER //
// ./src/utils/actionTypes.js